export const PHONE = "9428489428";
export const PHONE_LINK = "tel:+919428489428";
export const WHATSAPP_LINK =
    "https://wa.me/919428489428?text=Hello%20Pramukh%20Compliance%20Services%2C%20I%20would%20like%20to%20discuss%20labour%20law%20compliance%20for%20my%20business.";

export const NAV_LINKS = [
    { label: "Services", href: "#services" },
    { label: "Labour Codes", href: "#labour-codes" },
    { label: "Registers", href: "#registers" },
    { label: "Calendar", href: "#calendar" },
    { label: "Industries", href: "#industries" },
    { label: "Process", href: "#process" },
    { label: "Contact", href: "#contact" },
];

export const SERVICE_HIGHLIGHTS = [
    { title: "New Labour Code Compliance", desc: "Transition advisory and implementation support for the four consolidated Labour Codes." },
    { title: "Labour Law Compliance", desc: "End-to-end statutory compliance management under central and Gujarat state labour laws." },
    { title: "PT Registration & Compliance", desc: "PTEC & PTRC registration, payments, returns, amendments and closures." },
    { title: "Shop & Establishment", desc: "New registrations, renewals, amendments and closures under the S&E Act." },
    { title: "PF & ESIC", desc: "Registration, monthly ECR filings, contributions and employee compliance." },
    { title: "CLRA Compliance", desc: "Principal employer and contractor compliance under Contract Labour regulation." },
    { title: "BOCW Compliance", desc: "Building & Other Construction Workers registration, cess and records." },
    { title: "LWF Compliance", desc: "Labour Welfare Fund contributions, periodic payments and returns." },
    { title: "Statutory Registers", desc: "Identification, preparation and maintenance of applicable labour-law registers." },
    { title: "Compliance Calendar", desc: "Structured due-date tracking for monthly, quarterly and annual compliances." },
];

export const ROLE_ITEMS = [
    { title: "Compliance Assessment", desc: "Identify applicable labour laws, registrations, licences, returns and statutory registers." },
    { title: "Registration Support", desc: "Applications for registrations, licences, amendments, transfers and closures." },
    { title: "Compliance Calendar", desc: "A structured calendar covering monthly, quarterly, half-yearly and annual requirements." },
    { title: "Register Management", desc: "Applicable statutory registers and records required under labour laws." },
    { title: "Due-Date Monitoring", desc: "Compliance deadlines monitored with timely reminders and support." },
    { title: "Government Coordination", desc: "Documentation, clarification letters, applications and department communication." },
    { title: "Branch Compliance", desc: "New branches, address changes, employer changes and branch closures." },
];

export const GOALS = [
    "Reduce compliance risk",
    "Avoid missed statutory deadlines",
    "Maintain proper statutory records",
    "Simplify labour-law compliance",
    "Support during registrations & inspections",
    "Improve compliance documentation",
    "Timely, practical compliance support",
    "Stay prepared for regulatory changes",
];

export const LABOUR_CODES = [
    { name: "Code on Wages", desc: "Uniform wage definitions, minimum wages, timely payment and bonus provisions." },
    { name: "Industrial Relations Code", desc: "Trade unions, standing orders, retrenchment and dispute-resolution framework." },
    { name: "Code on Social Security", desc: "PF, ESIC, gratuity and social-security coverage including new worker categories." },
    { name: "OSH & Working Conditions Code", desc: "Safety, health, welfare and working-condition standards for establishments." },
];

export const LABOUR_CODE_COVERAGE = [
    "Applicability assessment",
    "Compliance gap assessment",
    "Required registers and records",
    "Wage and payroll compliance review",
    "Employee classification review",
    "Contractor compliance review",
    "Statutory documentation",
    "Compliance calendar",
    "Implementation support",
];

export const REGISTRATION_SERVICES = [
    {
        id: "pt",
        label: "Professional Tax",
        items: ["PTEC Registration", "PTRC Registration", "Amendment", "Address Change", "Employer Name Change", "Branch Registration", "Payment Support", "Return Compliance", "Certificate Collection", "Closure / Cancellation", "Department Clarification"],
    },
    {
        id: "se",
        label: "Shop & Establishment",
        items: ["New Registration", "Amendment", "Address Change", "Employer / Entity Name Change", "Employee Details", "Renewal & Applicable Compliance", "Closure", "Certificate Support", "Government Documentation"],
    },
    {
        id: "pfesic",
        label: "PF & ESIC",
        items: ["Registration Support", "Monthly Compliance", "ECR / Contribution Support", "Employee Compliance", "Employer Compliance", "ESIC Contribution Support", "Registration Amendments", "Transfer / Closure Support"],
    },
    {
        id: "clra",
        label: "CLRA",
        items: ["Principal Employer Compliance", "Contractor Compliance", "Registration / Licence Support", "Contractor Documentation", "Statutory Registers", "Returns and Due Dates", "Compliance Documentation"],
    },
    {
        id: "bocw",
        label: "BOCW",
        items: ["Registration Support", "Applicable Compliance", "Labour-Related Documentation", "Returns / Contributions Where Applicable", "Record and Register Support"],
    },
    {
        id: "lwf",
        label: "Labour Welfare Fund",
        items: ["Registration Where Applicable", "Employee Contribution", "Employer Contribution", "Periodic Payment", "Returns", "Compliance Monitoring"],
    },
];

export const REGISTER_CATEGORIES = [
    { title: "Employee Registers", items: ["Employee Master Register", "Attendance Register", "Wage Register", "Leave Register", "Overtime Register", "Employment-related records"] },
    { title: "Wage & Payment Records", items: ["Wage records", "Salary records", "Deduction records", "Overtime records", "Payment records"] },
    { title: "Contractor / Labour Records", items: ["Contractor Register", "Contract Labour records", "Principal Employer records", "Contractor documentation", "Worker deployment records"] },
    { title: "Safety & Establishment Records", items: ["Accident Register", "Safety records", "Inspection records", "Notices and statutory displays", "Other applicable registers"] },
];

export const CALENDAR_STEPS = [
    "Compliance Identified",
    "Due Date",
    "Reminder",
    "Documents",
    "Payment / Return",
    "Submission",
    "Proof",
    "Compliance Record",
];

export const CALENDAR_TRACKED = [
    "Monthly compliances", "Quarterly compliances", "Half-yearly compliances", "Annual compliances",
    "Registration renewals", "Licence expiry dates", "Return filing dates", "Contribution payment dates",
    "Statutory register updates", "Government submissions",
];

export const DEMO_DASHBOARD = [
    { compliance: "PT", due: "15/08/2026", status: "Pending", owner: "H. Patel", month: "August 2026" },
    { compliance: "PF", due: "15/08/2026", status: "Completed", owner: "R. Shah", month: "August 2026" },
    { compliance: "ESIC", due: "15/08/2026", status: "In Progress", owner: "R. Shah", month: "August 2026" },
    { compliance: "LWF", due: "31/08/2026", status: "Completed", owner: "H. Patel", month: "August 2026" },
    { compliance: "S&E", due: "31/12/2026", status: "Active", owner: "Compliance Team", month: "August 2026" },
    { compliance: "CLRA Return", due: "30/09/2026", status: "Overdue", owner: "H. Patel", month: "September 2026" },
    { compliance: "PT", due: "15/09/2026", status: "Pending", owner: "H. Patel", month: "September 2026" },
    { compliance: "PF", due: "15/09/2026", status: "In Progress", owner: "R. Shah", month: "September 2026" },
    { compliance: "ESIC", due: "15/09/2026", status: "Pending", owner: "R. Shah", month: "September 2026" },
    { compliance: "BOCW Cess", due: "30/09/2026", status: "Not Applicable", owner: "Compliance Team", month: "September 2026" },
];

export const GAP_REVIEW_ITEMS = [
    "Missing registrations", "Missing statutory registers", "Pending returns", "Unpaid contributions",
    "Incorrect employee classification", "Contractor compliance", "Expired licences",
    "Incorrect establishment information", "Missing documentation", "Missed due dates",
];

export const GAP_QUESTIONS = [
    {
        q: "Are all applicable labour-law registrations (PT, S&E, PF, ESIC, CLRA, LWF) in place for every branch?",
        options: [
            { label: "Yes, all registrations are in place", score: 0 },
            { label: "Some registrations are pending", score: 2 },
            { label: "Not sure what applies to us", score: 2 },
        ],
    },
    {
        q: "Are your statutory registers and records updated every month?",
        options: [
            { label: "Yes, regularly maintained", score: 0 },
            { label: "Updated occasionally", score: 1 },
            { label: "No registers maintained", score: 2 },
        ],
    },
    {
        q: "Do you track every return filing and contribution due date with reminders?",
        options: [
            { label: "Yes, with a structured calendar", score: 0 },
            { label: "We track a few manually", score: 1 },
            { label: "No due-date tracking", score: 2 },
        ],
    },
    {
        q: "Have you received a labour department notice or faced an inspection recently?",
        options: [
            { label: "No notices or inspections", score: 0 },
            { label: "Yes, and it was resolved", score: 1 },
            { label: "Yes, matters are pending", score: 2 },
        ],
    },
];

export const INDUSTRIES = [
    "Banking & Financial Services", "NBFCs", "IT & ITES", "Manufacturing", "Engineering",
    "Retail", "Logistics & Courier", "Construction", "Professional Services",
    "Corporate Offices", "Start-ups", "Branch-based Organisations", "Contractors & Service Providers",
];

export const WHY_US = [
    { title: "Practical Compliance Support", desc: "Business-focused and practical compliance assistance." },
    { title: "Timely Monitoring", desc: "Structured monitoring of statutory due dates." },
    { title: "Documentation Support", desc: "Professional preparation of applications, letters and statutory documents." },
    { title: "Government Coordination", desc: "Support for communication and documentation with relevant departments." },
    { title: "Branch-Level Support", desc: "Assistance for multiple branches and locations." },
    { title: "Compliance Records", desc: "Organised compliance documentation and proof records." },
    { title: "Regulatory Updates", desc: "Monitoring applicable regulatory and labour-law changes." },
];

export const PROCESS_STEPS = [
    { num: "01", title: "Understand", desc: "Understand the organisation, workforce and business activities." },
    { num: "02", title: "Assess", desc: "Identify applicable registrations, licences, returns and registers." },
    { num: "03", title: "Implement", desc: "Complete registrations, documentation and required compliance activities." },
    { num: "04", title: "Monitor", desc: "Track statutory due dates through the compliance calendar." },
    { num: "05", title: "Report", desc: "Maintain compliance records and provide status reports." },
];

export const SERVICE_OPTIONS = [
    "Labour Code Compliance", "PT", "Shop & Establishment", "PF", "ESIC", "CLRA",
    "BOCW", "LWF", "Labour Registers", "Compliance Calendar", "Compliance Audit", "Other",
];

export const EMPLOYEE_OPTIONS = ["1–10", "11–25", "26–50", "51–100", "101–500", "500+"];

export const MARQUEE_ITEMS = [
    "New Labour Codes", "PTEC & PTRC", "Shop & Establishment", "PF & ESIC", "CLRA",
    "BOCW", "LWF", "Statutory Registers", "Compliance Calendar", "Due-Date Management",
];
